export const nationality = {
  rexmonster: [
    {
      text: "Indian",
      id: "20601099-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Qatari",
      id: "20796509-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ce66d57b-f5bd-44c3-b725-9f4f829ec437",
      },
    },
    {
      text: "Pakistani",
      id: "2076f9aa-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ab9a99bd-82c4-47da-8f4e-97884a5602aa",
      },
    },
    {
      text: "Filipino",
      id: "204d846c-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
      },
    },
    {
      text: "Bangladeshi",
      id: "1fe774e7-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "88d3bb47-e930-485c-8342-793fac43c85d",
      },
    },
    {
      text: "Egyptian",
      id: "201fd556-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "8e6b50a6-ca7d-443c-8ff4-cc5123a474f3",
      },
    },
    {
      text: "Nigerian",
      id: "20753b19-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "608de6d6-645b-4c8c-907b-340e5045c4ae",
      },
    },
  ],
  monstergulf: [
    {
      text: "Qatari",
      id: "20796509-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ce66d57b-f5bd-44c3-b725-9f4f829ec437",
      },
    },
    {
      text: "Egyptian",
      id: "201fd556-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "8e6b50a6-ca7d-443c-8ff4-cc5123a474f3",
      },
    },
    {
      text: "Indian",
      id: "20601099-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Pakistani",
      id: "2076f9aa-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ab9a99bd-82c4-47da-8f4e-97884a5602aa",
      },
    },
    {
      text: "Lebanese",
      id: "2069fde8-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "3c56486a-1738-4122-b22c-03947ea648cd",
      },
    },
    {
      text: "Filipino",
      id: "204d846c-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
      },
    },
    {
      text: "Jordanian",
      id: "2064d9e1-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "98d81b6b-1a7d-4dc1-844a-5fcb19853ba0",
      },
    },
    {
      text: "Saudi",
      id: "207c1a67-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "c29d8ef7-91f0-40c9-926c-80f251ff584f",
      },
    },
  ],
  monstersingapore: [
    {
      text: "Singaporean",
      id: "207df68d-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "d0fbac9b-a9bb-47de-ace2-72dadcc086f4",
      },
    },
    {
      text: "Indian",
      id: "20601099-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Malaysian",
      id: "206e0816-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
      },
    },
    {
      text: "Filipino",
      id: "204d846c-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
      },
    },
    {
      text: "Burmese",
      id: "2017a111-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "046a68ae-b78e-4f82-b6f9-88e1970da1a4",
      },
    },
    {
      text: "Sri Lankan",
      id: "20809a67-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "3fd2e744-5112-40de-9321-b8ddf0850131",
      },
    },
    {
      text: "Chinese",
      id: "201b2577-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ef256401-22fd-43d1-90a7-d38d2ef1e908",
      },
    },
  ],
  monsterthailand: [
    {
      text: "Thai",
      id: "2083d15c-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "e07a6422-a4cf-4c66-b701-cd023d5fafbc",
      },
    },
    {
      text: "Indian",
      id: "20601099-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Chinese",
      id: "201b2577-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ef256401-22fd-43d1-90a7-d38d2ef1e908",
      },
    },
    {
      text: "Saudi",
      id: "207c1a67-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "c29d8ef7-91f0-40c9-926c-80f251ff584f",
      },
    },
    {
      text: "Burmese",
      id: "2017a111-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "046a68ae-b78e-4f82-b6f9-88e1970da1a4",
      },
    },
    {
      text: "Russian",
      id: "207a2ced-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "95cc8f0d-5926-4e40-b049-3f681423bcd6",
      },
    },
    {
      text: "Egyptian",
      id: "201fd556-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "8e6b50a6-ca7d-443c-8ff4-cc5123a474f3",
      },
    },
  ],
  monsterphilippines: [
    {
      text: "Filipino",
      id: "204d846c-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
      },
    },
    {
      text: "Indian",
      id: "20601099-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Chinese",
      id: "201b2577-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ef256401-22fd-43d1-90a7-d38d2ef1e908",
      },
    },
    {
      text: "American",
      id: "1fe42a63-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ff65a305-99b3-4604-9605-b3bfbf7c8f15",
      },
    },
    {
      text: "Cameroonian",
      id: "201937f5-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "6a6ed98f-b64b-4448-a43f-50d8f509f949",
      },
    },
    {
      text: "Pakistani",
      id: "2076f9aa-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ab9a99bd-82c4-47da-8f4e-97884a5602aa",
      },
    },
    {
      text: "Saudi",
      id: "207c1a67-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "c29d8ef7-91f0-40c9-926c-80f251ff584f",
      },
    },
    {
      text: "Nigerian",
      id: "20753b19-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "608de6d6-645b-4c8c-907b-340e5045c4ae",
      },
    },
  ],
  monstervietnam: [
    {
      text: "Vietnamese",
      id: "2086e5uub9-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "efe150f3-eaeb-419f-9b02-4b85b73a26df",
      },
    },
    {
      text: "Indian",
      id: "20601099-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Bahraini",
      id: "1fe739a2-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "d467ac59-2856-457c-a029-9c85721faa35",
      },
    },
    {
      text: "Saudi",
      id: "207c1a67-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "c29d8ef7-91f0-40c9-926c-80f251ff584f",
      },
    },
    {
      text: "Qatari",
      id: "20796509-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ce66d57b-f5bd-44c3-b725-9f4f829ec437",
      },
    },
    {
      text: "Omani",
      id: "2076a538-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "cc3cadb8-e6f6-4f07-a975-e7d4237cb9c5",
      },
    },
    {
      text: "Egyptian",
      id: "201fd556-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "8e6b50a6-ca7d-443c-8ff4-cc5123a474f3",
      },
    },
    {
      text: "Chinese",
      id: "201b2577-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ef256401-22fd-43d1-90a7-d38d2ef1e908",
      },
    },
    {
      text: "Malaysian",
      id: "206e0816-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
      },
    },
  ],
  monstermalaysia: [
    {
      text: "Malaysian",
      id: "206e0816-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
      },
    },
    {
      text: "Indian",
      id: "20601099-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Pakistani",
      id: "2076f9aa-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ab9a99bd-82c4-47da-8f4e-97884a5602aa",
      },
    },
    {
      text: "Bangladeshi",
      id: "1fe774e7-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "88d3bb47-e930-485c-8342-793fac43c85d",
      },
    },
    {
      text: "Chinese",
      id: "201b2577-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ef256401-22fd-43d1-90a7-d38d2ef1e908",
      },
    },
    {
      text: "Indonesian",
      id: "2060909a-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "17c96887-4203-4d4a-a771-2b213d0dc955",
      },
    },
    {
      text: "Filipino",
      id: "204d846c-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
      },
    },
    {
      text: "Kuwaiti",
      id: "2067b337-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "39326a1a-1a67-40b8-a0be-c688c66ed437",
      },
    },
  ],
  monsterindonesia: [
    {
      text: "Indonesian",
      id: "2060909a-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "17c96887-4203-4d4a-a771-2b213d0dc955",
      },
    },
    {
      text: "Indian",
      id: "20601099-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Egyptian",
      id: "201fd556-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "8e6b50a6-ca7d-443c-8ff4-cc5123a474f3",
      },
    },
    {
      text: "Bahraini",
      id: "1fe739a2-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "d467ac59-2856-457c-a029-9c85721faa35",
      },
    },
    {
      text: "Kuwaiti",
      id: "2067b337-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "39326a1a-1a67-40b8-a0be-c688c66ed437",
      },
    },
    {
      text: "Malaysian",
      id: "206e0816-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
      },
    },
    {
      text: "Omani",
      id: "2076a538-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "cc3cadb8-e6f6-4f07-a975-e7d4237cb9c5",
      },
    },
    {
      text: "Qatari",
      id: "20796509-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ce66d57b-f5bd-44c3-b725-9f4f829ec437",
      },
    },
    {
      text: "Chinese",
      id: "201b2577-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ef256401-22fd-43d1-90a7-d38d2ef1e908",
      },
    },
  ],
  monsterhongkong: [
    {
      text: "Hong Kong",
      id: "39080b2f-b091-11ea-bb0f-000c29abc036",
      extraInfo: {
        countryUuId: "aa3cc3b5-59b1-4673-a8ce-c410b8505348",
      },
    },
    {
      text: "Indian",
      id: "20601099-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "11e2b871-1b9e-48c0-a7a5-1174672ae846",
      },
    },
    {
      text: "Chinese",
      id: "201b2577-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ef256401-22fd-43d1-90a7-d38d2ef1e908",
      },
    },
    {
      text: "Filipino",
      id: "204d846c-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "1e8c041e-f263-42f6-a941-fa41ac61ee8d",
      },
    },
    {
      text: "Pakistani",
      id: "2076f9aa-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ab9a99bd-82c4-47da-8f4e-97884a5602aa",
      },
    },
    {
      text: "American",
      id: "1fe42a63-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "ff65a305-99b3-4604-9605-b3bfbf7c8f15",
      },
    },
    {
      text: "Egyptian",
      id: "201fd556-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "8e6b50a6-ca7d-443c-8ff4-cc5123a474f3",
      },
    },
    {
      text: "Malaysian",
      id: "206e0816-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "9917b387-7365-4167-8044-75c3ee8a919d",
      },
    },
    {
      text: "Taiwanese",
      id: "2082c7c7-fc81-11e8-92d8-000c290b6677",
      extraInfo: {
        countryUuId: "e5966b40-6f97-41b7-b7a7-51f8c5ddea0d",
      },
    },
  ],
};
